import {
    CoreApiFilterObject,
    FILTER_TYPES,
} from '@/coreApi/filters/coreApiFilterObject'

const FILTER_ID_PAGE_FILTER = 'pf'

const coreApiPageFilters = [
    {
        title: 'Referrers',
        key: 'r',
        field_name: 'referer_domain',
        filter_type: 'multiple-select',
        data: [
            {
                label: 'Direct',
                value: 'site_direct',
            },
            {
                label: 'Home',
                value: 'site_internal_home',
            },
            {
                label: 'Internal',
                value: 'site_internal',
            },
            {
                label: 'Infinite Scroll',
                value: 'site_internal_infinite_scroll',
            },
            {
                label: 'Google Organic',
                value: 'search_google_organic',
            },
            {
                label: 'Google Amp',
                value: 'search_google_amp',
            },
            {
                label: 'Google News',
                value: 'search_google_new',
            },
            {
                label: 'Google CPC',
                value: 'search_google_cpc',
            },
            {
                label: 'Google Discover',
                value: 'search_google_discover',
            },
            {
                label: 'Facebook',
                value: 'social_facebook',
            },
            {
                label: 'Facebook Instance Article',
                value: 'social_facebook_instant_article',
            },
            {
                label: 'Instagram',
                value: 'social_instagram_referrer',
            },
            {
                label: 'Twitter',
                value: 'social_twitter_referrer',
            },
            {
                label: 'Hurriyet',
                value: 'hurriyet',
            },
            {
                label: 'Milliyet',
                value: 'milliyet',
            },
            {
                label: 'Sabah',
                value: 'sabah',
            },
            {
                label: 'gazeteler.com',
                value: 'gazeteler.com',
            },
            {
                label: 'gazetekeyfi.com',
                value: 'gazetekeyfi',
            },
            {
                label: 'Yandex',
                value: 'yandex',
            },
            {
                label: 'Yahoo',
                value: 'yahoo',
            },
            {
                label: 'Sanalbasin',
                value: 'sanalbasin',
            },
            {
                label: 'f5haber.com',
                value: 'f5haber.com',
            },
            {
                label: 'eksisozluk.com',
                value: 'eksisozluk.com',
            },
            {
                label: 'Bundle',
                value: 'bundle',
            },
        ],
    },
    {
        title: 'Source Referrers',
        key: 'ord',
        field_name: 'origin_referer_domain',
        filter_type: 'multiple-select',
        data: [
            {
                label: 'Direct',
                value: 'site_direct',
            },
            {
                label: 'Google Organic',
                value: 'search_google_organic',
            },
            {
                label: 'Google Amp',
                value: 'search_google_amp',
            },
            {
                label: 'Google News',
                value: 'search_google_new',
            },
            {
                label: 'Google CPC',
                value: 'search_google_cpc',
            },
            {
                label: 'Google Discover',
                value: 'search_google_discover',
            },
            {
                label: 'Facebook',
                value: 'social_facebook',
            },
            {
                label: 'Facebook Instance Article',
                value: 'social_facebook_instant_article',
            },
            {
                label: 'Instagram',
                value: 'social_instagram_referrer',
            },
            {
                label: 'Twitter',
                value: 'social_twitter_referrer',
            },
            {
                label: 'Hurriyet',
                value: 'hurriyet',
            },
            {
                label: 'Milliyet',
                value: 'milliyet',
            },
            {
                label: 'Sabah',
                value: 'sabah',
            },
            {
                label: 'gazeteler.com',
                value: 'gazeteler.com',
            },
            {
                label: 'gazetekeyfi.com',
                value: 'gazetekeyfi',
            },
            {
                label: 'Yandex',
                value: 'yandex',
            },
            {
                label: 'Yahoo',
                value: 'yahoo',
            },
            {
                label: 'Sanalbasin',
                value: 'sanalbasin',
            },
            {
                label: 'f5haber.com',
                value: 'f5haber.com',
            },
            {
                label: 'eksisozluk.com',
                value: 'eksisozluk.com',
            },
            {
                label: 'Bundle',
                value: 'bundle',
            },
        ],
    },
    {
        title: 'UTM Referrers',
        key: 'ur',
        field_name: 'referer_utm',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            'bundle',
            'email',
            'f5haber',
            'facebook',
            'haberler.com',
            'gazetekeyfi',
            'gazeteoku',
            'google',
            'guncelhaberler',
            'webpush',
            't.co',
            'taboola',
        ],
    },
    {
        title: 'UTM Source Referrers',
        key: 'usr',
        field_name: 'origin_referer_utm',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            'bundle',
            'email',
            'f5haber',
            'facebook',
            'haberler.com',
            'gazetekeyfi',
            'gazeteoku',
            'google',
            'guncelhaberler',
            'webpush',
            't.co',
            'taboola',
        ],
    },
    {
        title: 'Devices',
        key: 'd',
        field_name: 'device',
        filter_type: 'checkbox',
        data: [
            {
                label: 'Desktop',
                value: 'desktop',
            },
            {
                label: 'Mobile',
                value: 'mobile',
            },
            {
                label: 'Tablet',
                value: 'tablet',
            },
        ],
    },
    {
        title: 'Sources',
        key: 's',
        field_name: 'source',
        filter_type: 'checkbox',
        data: [
            {
                label: 'Web',
                value: 'web',
            },
            {
                label: 'Amp',
                value: 'amp',
            },
            {
                label: 'Instance Article',
                value: 'ia',
            },
            {
                label: 'Android App',
                value: 'androidApp',
            },
            {
                label: 'IOS App',
                value: 'iosApp',
            },
        ],
    },
    {
        title: 'Domains',
        key: 'ds',
        field_name: 'page_domains',
        filter_type: 'checkbox',
        data: [
            {
                label: 'www.fanatik.com.tr',
                value: 'www.fanatik.com.tr',
            },
        ],
    },
    {
        title: 'Categories',
        key: 'c',
        field_name: 'breadcrumb_search',
        filter_type: 'multiple-select',
        data: [
            { label: 'Futbol', value: 'futbol' },
            { label: 'Hentbol', value: 'hentbol' },
            { label: 'Süper Lig', value: 'super lig' },
            { label: 'Transfer', value: 'transfer' },
            { label: 'Voleybol', value: 'voleybol' },
            { label: 'Yazarlar', value: 'yazarlar' },
            { label: 'Yüzme', value: 'yuzme' },
        ],
    },
    {
        title: 'Authors',
        key: 'a',
        field_name: 'author_search',
        filter_type: 'multiple-select',
        data: [
            { label: 'Ahmet Ağaoğlu', value: 'ahmetagaoglu' },
            { label: 'Ahmet Melik Subaşı', value: 'ahmetmeliksubasi' },
            { label: 'Ali Ece', value: 'aliece' },
            { label: 'Alican Esenci', value: 'alicanesenci' },
            { label: 'Andrii Varchak', value: 'andriivarchak' },
            { label: 'Arda Erol', value: 'ardaerol' },
            { label: 'Asena Özkan', value: 'asenaozkan' },
            { label: 'Aslıhan Çil', value: 'aslihançil' },
            { label: 'Atalay Özçelikli', value: 'atalayozcelikli' },
            { label: 'Ayhan Yılmaz', value: 'ayhanyilmaz' },
            { label: 'Ayşenur Afyon', value: 'aysenurafyon' },
            { label: 'Barbaros Tapan', value: 'barbarostapan' },
            { label: 'Barış Yengioğlu', value: 'barisyengioglu' },
            { label: 'Başak Koç', value: 'basakkoc' },
            { label: 'Basri Baykoç', value: 'basribaykoc' },
            { label: 'Bekir Emre', value: 'bekiremre' },
            { label: 'Besim Güçtenkorkmaz', value: 'besimguctenkorkmaz' },
            { label: 'Bülent Uygun', value: 'bulentuygun' },
            { label: 'Burak Özkarpuzcu', value: 'burakozkarpuzcu' },
            { label: 'Burak Uçar', value: 'burakucar' },
            { label: 'Can Çobanoğlu', value: 'cancobanoglu' },
            { label: 'Can Gebetaş', value: 'cangebetas' },
            { label: 'Can Tongo', value: 'cantongo' },
            { label: 'Cem Can', value: 'cemcan' },
            { label: 'Cem Dizdar', value: 'cemdizdar' },
            { label: 'Cem Şengül', value: 'cemsengul' },
            { label: 'Cenk İşler', value: 'cenki̇sler' },
            { label: 'Deniz Çoban', value: 'denizcoban' },
            { label: 'Murat Baş', value: 'muratbas' },
            { label: 'Ebru Köksaldı', value: 'ebrukoksaldi' },
            { label: 'Edip Adanır', value: 'edipadanir' },
            { label: 'Emine Sporel Özakat', value: 'eminesporelozakat' },
            { label: 'Emre Can', value: 'emrecan' },
            { label: 'Emre Tilev', value: 'emretilev' },
            { label: 'Engin Kehale', value: 'enginkehale' },
            { label: 'Engin Saydam', value: 'enginsaydam' },
            { label: 'Ercan Taner', value: 'ercan aner' },
            { label: 'Erdoğan Şenay', value: 'erdogansenay' },
            { label: 'Ergun Ata', value: 'ergunata' },
            { label: 'Erman Özgür', value: 'ermanozgur' },
            { label: 'Ertuğrul Oruç', value: 'ertugruloruc' },
            { label: 'Esat Soydabircan', value: 'esatsoydabircan' },
            { label: 'Eylem Türk', value: 'eylemturk' },
            { label: 'Faik Çetiner', value: 'faikcetiner' },
            { label: 'Fatih Demireli', value: 'fatihdemireli' },
            { label: 'Feyyaz Uçar', value: 'feyyazucar' },
            { label: 'Gökhan German', value: 'gokhangerman' },
            { label: 'Gökmen Özcan', value: 'gokmenozcan' },
            { label: 'Hakan Ateşler', value: 'hakanatesler' },
            { label: 'Hakan Can', value: 'hakancan' },
            { label: 'Hami Mandıralı', value: 'hamimandirali' },
            { label: 'Hamit Turhan', value: 'hamitturhan' },
            { label: 'Harun Can Aydın', value: 'haruncanaydin' },
            { label: 'Hasan Ali Atasoy', value: 'hasanaliatasoy' },
            { label: 'Hasan Tankaya', value: 'hasantankaya' },
            { label: 'Haşim Şahin', value: 'hasimsahin' },
            { label: 'Hatice Yücel', value: 'haticeyucel' },
            { label: 'Hırant Kasapoğlu', value: 'hirantkasapoglu' },
            { label: 'Hüseyin Hayali', value: 'huseyinhayali' },
            { label: 'Hüseyin Sakarya', value: 'huseyinsakarya' },
            { label: 'İlhan Söyler', value: 'i̇lhansoyler' },
            { label: 'İlker Dilek', value: 'i̇lkerdilek' },
            { label: 'İrfan Yardım', value: 'i̇rfanyardim' },
            { label: 'İsmet Tongo', value: 'i̇smettongo' },
            { label: 'Kaan Ark', value: 'kaanark' },
            { label: 'Kaan Bora', value: 'kaanbora' },
            { label: 'M. Çağrı Davran', value: 'm.çagridavran' },
            { label: 'Mehmet Ali Sabuncu', value: 'mehmetalisabuncu' },
            { label: 'Mehmet Caner Kolağasıgil', value: 'mehmetcanerkolagasigil' },
            { label: 'Mehmet Demircan', value: 'mehmetdemircan' },
            { label: 'Mehmet Demirkol', value: 'mehmetdemirkol' },
            { label: 'Mehmet Y. Yılmaz', value: 'mehmety.yilmaz' },
            { label: 'Melih Esen Cengiz', value: 'melihesencengiz' },
            { label: 'Mesut Konukçu', value: 'mesutkonukcu' },
            { label: 'Metin Gürsoy', value: 'metingursoy' },
            { label: 'Metin Karabaş', value: 'metinkarabas' },
            { label: 'Metin Tükenmez', value: 'metintukenmez' },
            { label: 'Müfit Öztürk', value: 'mufitozturk' },
            { label: 'Murat Akbaş', value: 'muratakbas' },
            { label: 'Murat Kuloğlu', value: 'muratkuloglu' },
            { label: 'Mustafa Denizli', value: 'mustafadenizli' },
            { label: 'Necati Özdeniz', value: 'necatiozdeniz' },
            { label: 'Necil Ülgen', value: 'necilulgen' },
            { label: 'Nejat Biyediç', value: 'nejatbiyedic' },
            { label: 'Nezih Alkış', value: 'nezihalkis' },
            { label: 'Nilay Yılmaz', value: 'nilayyilmaz' },
            { label: 'Nurettin Lüleci', value: 'nurettinluleci' },
            { label: 'Nurullah Demir', value: 'nurullahdemir' },
            { label: 'Oğuz Dizer', value: 'oguzdizer' },
            { label: 'Okan Çellik', value: 'okancellik' },
            { label: 'Olcay Çakır', value: 'olcaycakir' },
            { label: 'Ömer Gürsoy', value: 'omergursoy' },
            { label: 'Ömer Necati Albayrak', value: 'omernecatialbayrak' },
            { label: 'Ömer Ural Kükner', value: 'omeruralkukner' },
            { label: 'Orhan Yıldırım', value: 'orhanyildirim' },
            { label: 'Osman Şenher', value: 'osmansenher' },
            { label: 'Raşit Altun', value: 'rasitaltun' },
            { label: 'Safa Can Konuksever', value: 'safacankonuksever' },
            { label: 'Salih Güngör', value: 'salihgungor' },
            { label: 'Sedat Hardal', value: 'sedathardal' },
            { label: 'Selçuk Kılınç', value: 'selcukkilinc' },
            { label: 'Serdar Dinçbaylı', value: 'serdardincbayli' },
            { label: 'Serdar Tatlı', value: 'serdartatli' },
            { label: 'Sergen Yalçın', value: 'sergenyalcin' },
            { label: 'Serhat Akın', value: 'serhatakin' },
            { label: 'Serhat Demirtaş', value: 'serhatdemirtas' },
            { label: 'Serkan Akcan', value: 'serkanakcan' },
            { label: 'Serkan Hacıoğlu', value: 'serkanhacioglu' },
            { label: 'Süleyman Hatısaru', value: 'suleymanhatisaru' },
            { label: 'Tamer Bağlan', value: 'tamerbaglan' },
            { label: 'Tanju Çolak', value: 'tanjucolak' },
            { label: 'Tolga Umay', value: 'tolgaumay' },
            { label: 'Tunç Kayacı', value: 'tunckayaci' },
            { label: 'Umut Eken', value: 'umuteken' },
            { label: 'Vedat Bayram', value: 'vedatbayram' },
            { label: 'Yakup Çınar', value: 'yakupcinar' },
            { label: 'Yalçın Dümer', value: 'yalcindumer' },
            { label: 'Yalçın Türk', value: 'yalcinturk' },
            { label: 'Yalçın Uygun', value: 'yalcinuygun' },
            { label: 'Yasin Cam', value: 'yasincam' },
            { label: 'Yemen Ekşioğlu', value: 'yemeneksioglu' },
            { label: 'Yunuz Altun', value: 'yunuzaltun' },
            { label: 'Yusuf Dursun', value: 'yusufdursun' },
            { label: 'Zafer Büyükavcı', value: 'zaferbuyukavci' },
        ],
    },
    {
        title: 'Editors',
        key: 'ed',
        field_name: 'author_search',
        filter_type: 'multiple-select',
        data: [
            { label: 'atalayozcelikli', value: 'atalayozcelikli' },
            { label: 'Ayşenur Toprak', value: 'atoprak' },
            { label: 'birkanekinci', value: 'birkanekinci' },
            { label: 'boraaslan', value: 'boraaslan' },
            { label: 'bugrakolagasigil', value: 'bugrakolagasigil' },
            { label: 'burakozdemir', value: 'burakozdemir' },
            { label: 'cagrikucuk', value: 'cagrikucuk' },
            { label: 'canerkolagasigil', value: 'canerkolagasigil' },
            { label: 'cemil.akosman', value: 'cemil.akosman' },
            { label: 'Cengiz Gür', value: 'cengiz.gur' },
            { label: 'Cevat Sarıkaya', value: 'csarikaya' },
            { label: 'Çiğdem Aydın', value: 'caydin' },
            { label: 'emre.topaloglu', value: 'emre.topaloglu' },
            { label: 'emre.topaloglu1', value: 'emre.topaloglu1' },
            { label: 'emrekayranci', value: 'emrekayranci' },
            { label: 'erdembayramic', value: 'erdembayramic' },
            { label: 'esatsoydabircan', value: 'esatsoydabircan' },
            { label: 'Fanatik', value: 'Fanatik' },
            { label: 'gizemcelikbas', value: 'gizemcelikbas' },
            { label: 'Gülgün Yavuz', value: 'gyavuz' },
            { label: 'haticemerve.mutlu', value: 'haticemerve.mutlu' },
            { label: 'hhaspor', value: 'hhaspor' },
            { label: 'kaankarahan', value: 'kaankarahan' },
            { label: 'maydin', value: 'maydin' },
            { label: 'Melih Buğra Kolağasıgil', value: 'bugrakolagasigil' },
            { label: 'migration', value: 'migration' },
            { label: 'nuzel', value: 'nuzel' },
            { label: 'okaneren', value: 'okaneren' },
            { label: 'onurdurmus', value: 'onurdurmus' },
            { label: 'onurguler', value: 'onurguler' },
            { label: 'orcunkonaklilar', value: 'orcunkonaklilar' },
            { label: 'PAF DEVELOPER 2', value: 'pafdeveloper2' },
            { label: 'Rabia Neziha Yıldız', value: 'rabia.neziha' },
            { label: 'smentes', value: 'smentes' },
            { label: 'tkuru', value: 'tkuru' },
            { label: 'umuteken', value: 'umuteken' },
            { label: 'yakupcinar', value: 'yakupcinar' },
            { label: 'yildirimkilic', value: 'yildirimkilic' },
            { label: 'yunusdilber', value: 'yunusdilber' },
        ],
    },
    {
        title: 'User Type',
        key: 'ut',
        field_name: 'user_types',
        filter_type: 'checkbox',
        data: [
            {
                label: 'Anonymous',
                value: 'anonymous',
            },
            {
                label: 'Paid',
                value: 'paid',
            },
            {
                label: 'Logged In',
                value: 'loggedin',
            },
        ],
    },
    {
        title: 'Keywords',
        key: 'kw',
        field_name: 'keywords',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            'seohaber',
        ],
    },
    {
        title: 'Keywords Exclude',
        key: 'kwn',
        field_name: 'not_keywords',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            'seohaber',
        ],
    },
    {
        title: 'Search',
        key: 'srch',
        field_name: 'search_include',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            '404 hata sayfası',
        ],
    },
]

export const coreApiPageFilterFanatikObject = new CoreApiFilterObject(FILTER_ID_PAGE_FILTER, FILTER_TYPES.VALUES, coreApiPageFilters)
